// @flow

import * as React from 'react';
import { ApolloConsumer } from 'react-apollo';
import Logging from '@ta/common.logging';

import UntagUserReference from './UntagUserReference.gql';
import UpdateSocialReferences from './UpdateSocialReferences.gql';

type Props = {|
  /** A render prop that exposes whether or not the object has been untagged */
  children: (object: (any) => void) => React.Node,
|};

const specialIdNameMap = {
  Repost: 'repostId',
  LinkPost: 'postId',
};

export const DisplayUntagIcon = (item: any, currentUserId?: string) =>
  item &&
  currentUserId &&
  item.socialReferences &&
  item.socialReferences.userReferences &&
  item.socialReferences.userReferences.find(o => o.userId === currentUserId);

class UntagAction extends React.Component<Props> {
  getId = (object: any) =>
    specialIdNameMap[object.__typename] ? object[specialIdNameMap[object.__typename]] : object.id;

  getType = (object: any) =>
    object.__typename === 'TripComment' ? 'COMMENT' : object.__typename.toUpperCase();

  render() {
    return (
      <ApolloConsumer>
        {client =>
          this.props.children((object: any) => {
            const updateQuery = {
              updatePhoto: object.__typename === 'Photo',
              updateVideo: object.__typename === 'Video',
              updateRepost: object.__typename === 'Repost',
              updateLinkPost: object.__typename === 'LinkPost',
              updateTrip: object.__typename === 'Trip',
              updateTripComment: object.__typename === 'TripComment',
            };
            if (updateQuery) {
              client
                .mutate({
                  mutation: UntagUserReference,
                  variables: {
                    id: this.getId(object),
                    type: this.getType(object),
                  },
                })
                // get updated the social reference and re-render it
                .then(() =>
                  client.query({
                    query: UpdateSocialReferences,
                    variables: {
                      idInt: this.getId(object),
                      idLong: this.getId(object),
                      ...updateQuery,
                    },
                  }),
                )
                .then(() => {
                  this.forceUpdate();
                })
                .catch(error => Logging.error(`Untag User Reference failed. Reason: ${error}`));
            }
          })
        }
      </ApolloConsumer>
    );
  }
}

export default UntagAction;
